import * as React from "react";
import * as ReactDOM from "react-dom";
import { LWPComponent } from "VSSPreview/Flux/Components/LWP";
import { SecurityDialogOptions } from "Admin/Scripts/TFS.Admin.Security";

export interface ResourceSecurityPanelProps extends SecurityDialogOptions { }

export interface ResourceSecurityPanelState {
    viewResourceSecurity: boolean;
}

export function renderResourceSecurityPanelUX(props: SecurityDialogOptions) {
    ReactDOM.render(<ResourceSecurityPanel {...props as ResourceSecurityPanelProps} />, document.createElement("div"));
}

export class ResourceSecurityPanel extends React.Component<ResourceSecurityPanelProps, ResourceSecurityPanelState> {

    constructor(props: ResourceSecurityPanelProps, context: any) {
        super(props, context);

        this.state = {
            viewResourceSecurity: true
        } as ResourceSecurityPanelState
    }

    public render(): JSX.Element {
        return (
            <div>
                {this.state.viewResourceSecurity &&
                    (<LWPComponent
                        dependencies={["ms.vss-admin-web.security-view-common-content"]}
                        wrappedType="ms.vss-admin-web.security-panel-component"
                        onCancel={this._onSecurityPanelCancel}
                        securityViewTitle={this.props.tokenDisplayVal}
                        permissionSetId={this.props.permissionSet}
                        permissionSetToken={this.props.token}
                    />
                    )}

            </div>
        );
    }

    private _onSecurityPanelCancel = () => {
        this.setState({
            viewResourceSecurity: false
        });
    };
}
